import { render, staticRenderFns } from "./MilageVehicleModalSingle.vue?vue&type=template&id=642861dd"
import script from "./MilageVehicleModalSingle.vue?vue&type=script&lang=js"
export * from "./MilageVehicleModalSingle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports